import * as React from 'react';
import AmCharts from "@amcharts/amcharts3-react";
import { _ } from "@src/services/i18n";
import { classNames, css, mixin, vars, defaultProps, formatters } from '@src/services/theme';
import { Proto, Props, State } from '@src/components/Proto';
import { Box } from '@src/components';

// typing

// style
const style = css`
    display: flex;
    
    > .soh {
        width: 70%;

        .legend-line {
            ${mixin.legend}
        }
    }
    > .status {
        width: 30%;

        > footer {
            padding: 10px;
            font-size: 20px;
            line-height: 30px;
            text-align: center;
            background: #cccccc;
            border-radius: ${60}px;
        }
    }
`;

// component
export class Soh extends Proto<Props, State> {

    parseGraphData( ) {
        const { data } = this.state;
        const sd = data.data.sohdata;
        const soh = sd.map( v => {
            const {cycle, soh, DOF, cycle_number} = v;
            return {
                cycle,
                cycle_number,
                val: soh,
                dof: DOF
            };
        }).filter( v => v.val );
        const ideal = sd.map( v => {
            const {cycle, idealsoh, DOF, cycle_number}= v;
            return {
                cycle,
                cycle_number,
                ideal: idealsoh
            };
        }).filter( v => v.ideal );

        return [
            ...soh,
            ...ideal
        ];
    }

    findLastValue( ) {
        const { data } = this.state;
        const { sohdata } = data.data;

        let lastPoint = sohdata[0];
        for (let point of sohdata) {
            if (point.hidden_idealsoh != null && point.soh != null) {
                lastPoint = point;
            } 
        }

        return lastPoint;
    }

	// render
	render() {
        const loading = this.loading();
        if (loading) return loading;
        const { data } = this.state;
        const { sohdata } = data.data;

        const config = {
            "type": "xy",
            "theme": "light",
            "marginRight": 80,
            "dataDateFormat": "YYYY-MM-DD",
            "startDuration": 1.5,
            "trendLines": [],
            "decimalSeparator": ',',
            "thousandsSeparator": '',
            "balloon": {
                "adjustBorderColor": false,
                "shadowAlpha": 0,
                "fixedPosition": true
            },
            "graphs": [{
                "balloonText": "<div style='margin:5px;'><b>Cycle [[x]]</b><br>SOH:<b>[[y]]</b><br>DOF:<b>[[DOF]]</b></div>",
                "bullet": "diamond",
                "maxBulletSize": 25,
                "lineAlpha": 0.8,
                "lineThickness": 2,
                "lineColor": vars.colors.orange,
                "fillAlphas": 0,
                "xField": "cycle_number",
                "yField": "val",
                "valueField": "5"
            }, {
                "balloonText": "<div style='margin:5px;'><b>Cycle [[x]]</b><br>Ideal SOH:<b>[[y]]</b><br>DOF:<b>[[DOF]]</b></div>",
                "bullet": "round",
                "maxBulletSize": 25,
                "lineAlpha": 0.8,
                "lineThickness": 2,
                "lineColor": vars.colors.green,
                "fillAlphas": 0,
                "xField": "cycle_number",
                "yField": "ideal",
                "valueField": "5"
            }],
            "valueAxes": [{
                "id": "ValueAxis-1",
                "axisAlpha": 0,
                "position": "left",
                "title": _('soh_graph_soh2', 'BatteryOverview'),
                "maximum": 100,
                "minimum": 0,
            }, {
                "id": "ValueAxis-2",
                "minimum":sohdata[0].cycle_number,
                "axisAlpha": 0,
                "position": "bottom",
                "title": _('soh_graph_completed', 'BatteryOverview'),
                "precision":0
            }],
            "allLabels": [],
            "titles": [],
            "dataProvider": this.parseGraphData()
        };

        const last = this.findLastValue();


        const config2 = {
            "theme": "light",
            "type": "serial",
            "startDuration": 2,
            "dataProvider": [
                { title: _('soh_graph_ideal', 'BatteryOverview'), value: last.hidden_idealsoh, color: vars.colors.green },
                { title: _('soh_graph_soh', 'BatteryOverview'), value: last.soh, color: vars.colors.orange }
            ],
            "graphs": [{
                "balloonText": "[[category]]: <b>[[value]]%</b>",
                "fillColorsField": "color",
                "fillAlphas": 1,
                "lineAlpha": 0.1,
                "type": "column",
                "valueField": "value",
            }],
            "depth3D": 20,
            "angle": 30,
            "chartCursor": {
                "categoryBalloonEnabled": false,
                "cursorAlpha": 0,
                "zoomable": false
            },
            "categoryField": "title",
            "valueAxes": [{
                "id": "ValueAxis-2-1",
                "axisAlpha": 0,
                "position": "left",
                "title": _('soh_graph_soh2', 'BatteryOverview'),
                "maximum": 100,
                "minimum": 0,
            }, {
                "id": "ValueAxis-2-2",
                "axisAlpha": 0,
                "position": "bottom",
                "title": _('soh_graph_completed', 'BatteryOverview'),
                "precision": 0
            }],
        };
        
        
		return (
            <Box
            title="State of Health"
            collapsed={false}
            nodata={data.data.sohdata.filter( v => v.soh ).length === 0}
            >
                <div className={style}>
                    <section className="soh">
                        <AmCharts.React style={{ width: "100%", height: "400px" }} options={config} />

                        <div className="legend-line">
                            <span className="lgnd-orange">{_('soh_graph_soh', 'BatteryOverview')}</span>
                            <span className="lgnd-green">{_('soh_graph_ideal', 'BatteryOverview')}</span>
                        </div>
                    </section>
                    <section className="status">
                        <AmCharts.React style={{ width: "100%", height: "400px" }} options={config2} />
                        <footer>
                            {/*<div>Status of {formatters.date(current_soh.date)}</div>*/}
                            <strong>{formatters.number(last.hidden_idealsoh - last.soh, { precision: 2 } )}%</strong>
                        </footer>
                    </section>
                </div>
            </Box>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/BatteryOverview/Soh.tsx